import { Box, Stack, styled } from "@mui/material";
import { BodyTextM } from "../Typography";

export const InvestmentStrategyIntroStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: "75%",
        margin: "48px auto",
        textAlign: "center",
    }),
);

export const InvestmentStrategyIntroImageBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        alignSelf: "center",
        maxWidth: 216,
    }),
);

export const InvestmentStrategyIntroBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        alignSelf: "center",
    }),
);
